import axios from 'src/utils/axios';
import { URLS } from 'src/submodules/commons-system/constants/urls';
import authService from './authService';
import configService from './configService';

const STORAGE_KEYS = {
	TENANTS: 'tenants',
	CURRENT_TENANT: 'currentTenant'
}
let logoCache = {};
class TenatService {

	setTenants(t){
		localStorage.setItem(STORAGE_KEYS.TENANTS, JSON.stringify(t || null));
				
		// AGGIUNGI CURRENT TENANT AD HEADER "X-SCF-Tenant"
		let currentTenant = tenantsService.getCurrentTenant();

		if(currentTenant) {
			axios.defaults.headers.common['X-SCF-Tenant'] = currentTenant?.id || null;
		}
	}

	getTenants(){
		return JSON.parse(localStorage.getItem(STORAGE_KEYS.TENANTS));
	}

setCurrentTenant(t) {
		localStorage.setItem(STORAGE_KEYS.CURRENT_TENANT, JSON.stringify(t));
		authService.saveCookies(STORAGE_KEYS.CURRENT_TENANT, JSON.stringify(t))
		window.location.reload();
	}

	getCurrentTenant() {
		let tenants = this.getTenants();
		let currentFromCookie = authService.getCookies(STORAGE_KEYS.CURRENT_TENANT);
		let current =  JSON.parse(localStorage.getItem(STORAGE_KEYS.CURRENT_TENANT));
		if(currentFromCookie){
			current = JSON.parse(currentFromCookie)
		}
		if (current) return current;

		if (tenants && tenants?.length > 0) {
			current = tenants[0];
			localStorage.setItem(
				STORAGE_KEYS.CURRENT_TENANT,
				JSON.stringify(tenants[0])
			);

			return current;
		}
	}

	clearStorage(){
		localStorage.removeItem(STORAGE_KEYS.TENANTS);
		localStorage.removeItem(STORAGE_KEYS.CURRENT_TENANT);
		delete axios.defaults.headers.common['X-SCF-Tenant'];
	}

		getLogo(size) {
		let defaultLogo = '/static/images/logo-ohm.png';
		let tenant = this.getCurrentTenant();
		let token = authService.getAccessToken();

		const cacheKey = `${tenant?.id}-${size}`;

		if (logoCache[cacheKey]) {
			return Promise.resolve(logoCache[cacheKey]);
		}

		if (tenant && token) {
			const url =
				size === 'large'
					? `${URLS.TENANTS}/${tenant.id}/logoLarge`
					: `${URLS.TENANTS}/${tenant.id}/logoSmall`;

			return axios({
				method: 'GET',
				url: url,
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(res => {
					const url =
						res?.data?.size > 0
							? window.URL.createObjectURL(new Blob([res.data]))
							: defaultLogo;
					logoCache[cacheKey] = url;
					const encode = btoa(JSON.stringify(url));
					localStorage.setItem('LOGO', encode);
					return url;
				})
				.catch(() => defaultLogo);
		} else {
			let conf = configService.getConfigByKey();
			const icon = conf?.appIcon || defaultLogo;
			logoCache[cacheKey] = icon;
			return Promise.resolve(icon);
		}
	}

}

const tenantsService = new TenatService();

export default tenantsService;